/** Lowercase product slug / package-style identifier (storage keys stay `wundrlst_*`). */
export const APP_NAME = "wundrlst"

/** Title case for UI, document titles, and emails. */
export const APP_NAME_TITLE = "Wundrlst"

/** Replaces legacy `travelpro` segments in `/blog/:slug` URLs (case-insensitive). */
export function rewriteLegacyTravelproBlogSlug(slug: string): string {
  return slug.replace(/travelpro/gi, APP_NAME)
}
